import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b510ad3a")

_pushScopeId("data-v-b510ad3a")
const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("b", null, "Please correct the following error(s):", -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", null, "신고 유형", -1)
const _hoisted_8 = {
  role: "group",
  class: "form-group"
}
const _hoisted_9 = { class: "col-form-label col-sm-3 pl-0" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("신고자[")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("]")
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("신고 대상 ID[")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("]")
const _hoisted_15 = {
  key: 0,
  class: "form-group"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode("신고 대상 컨텐츠의 작성자 ID[")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("]")
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/_createVNode("label", null, "신고 사유 유형", -1)
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", null, "신고 사유", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SubmitButton = _resolveComponent("SubmitButton")

  return (_openBlock(), _createBlock("div", {
    class: ["card", {loading: _ctx.loading}]
  }, [
    _createVNode("div", _hoisted_1, [
      (_ctx.errors.length)
        ? (_openBlock(), _createBlock("p", _hoisted_2, [
            _hoisted_3,
            _createVNode("ul", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
                return (_openBlock(), _createBlock("li", { key: error }, _toDisplayString(error), 1))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("form", {
        onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.report.type = $event)),
                required: "",
                readonly: "readonly"
              }, null, 512), [
                [_vModelText, _ctx.report.type]
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("label", _hoisted_9, [
                _hoisted_10,
                _createVNode("a", {
                  href: `/user-management/edit/uid/${_ctx.report.reporter_id}`,
                  class: "text-reset",
                  target: "_blank"
                }, "바로가기", 8, ["href"]),
                _hoisted_11
              ]),
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.report.reporter_id = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.report.reporter_id]
              ])
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("label", null, [
                _hoisted_13,
                (_ctx.report.target_id)
                  ? (_openBlock(), _createBlock("a", {
                      key: 0,
                      href: _ctx.targetIdLink,
                      class: "text-reset",
                      target: "_blank"
                    }, "바로가기", 8, ["href"]))
                  : _createCommentVNode("", true),
                _hoisted_14
              ]),
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.report.target_id = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.report.target_id]
              ])
            ]),
            (_ctx.report.target_user_id)
              ? (_openBlock(), _createBlock("div", _hoisted_15, [
                  _createVNode("label", null, [
                    _hoisted_16,
                    _createVNode("a", {
                      href: `/user-management/edit/uid/${_ctx.report.target_user_id}`,
                      class: "text-reset",
                      target: "_blank"
                    }, "바로가기", 8, ["href"]),
                    _hoisted_17
                  ]),
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.report.target_user_id = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.report.target_user_id]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_18, [
              _hoisted_19,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.reportReasonTypeName = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.reportReasonTypeName]
              ])
            ]),
            _createVNode("div", _hoisted_20, [
              _hoisted_21,
              _withDirectives(_createVNode("textarea", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.report.remark = $event)),
                required: "",
                rows: "10"
              }, null, 512), [
                [_vModelText, _ctx.report.remark]
              ])
            ])
          ])
        ]),
        _createVNode(_component_SubmitButton, {
          text: "저장",
          loadingText: " Saving...",
          isSubmitting: _ctx.isSubmitting
        }, null, 8, ["isSubmitting"]),
        _createVNode("button", {
          class: "btn btn-danger ml-3 px-4",
          onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.moveList && _ctx.moveList(...args)), ["prevent"]))
        }, "목록")
      ], 32)
    ])
  ], 2))
})